import React  from 'react';

import jianglixize651 from '../assets/img/jianglixize651.png';
import tousushouliren652 from '../assets/img/tousushouliren652.png';

const Enclosure65 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3></h3>
            <p>2020年为更加合理利用集团公司人力资源、客户资源、品牌资源，配件业务管理公司特制定配件《全员配件营销季度激励管理办法》，具体细则如下：</p>
            <h4>一、实施时间：</h4>
            <p>2020年1月1日起</p>
            <h4>二、兑现单位及实施对象：</h4>
            <p>1、配件营销激励由品牌事业部统计并报管理公司审核后上报集团公司财务部审批，因奖励所产生的费用全部计算在配件管理公司成本中。</p>
            <p>2、全集团公司非专职配件营销岗位及总经理以下岗位（含总经理）和客户直销。</p>
            <h4>三、非专职营销岗位定义：</h4>
            <p>1、不在配件业务管理公司担任职务的人员</p>
            <p>2、集团公司其他营销机构不用配件销量考核或计算绩效的人员</p>
            <p>3、在集团公司担任配件营销工作但和配件业务管理公司经营品牌不重叠的人员。</p>
            <h4>四、奖励细则：</h4>
            <br/>
            <img src={jianglixize651} alt="" style={{
                width  : '80%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/>
            <p>说明:</p>
            <p>1、提供的信息，经配件业务管理公司专人核实后真实有效且非在售客户（半年内）和客户的下游渠道。</p>
            <p>2、所有奖励均为动态积分奖励增加至次月当事人的动态积分中。（悦积分）</p>
            <p>3、个人直接销售的根据金额按照配件业务员管理公司营销专员绩效发放在次月兑现，不再增加动态积分。</p>
            <p>4、额外激励：季度信息提供第一名奖励300分，下月度兑现。</p>
            <p>5、额外激励：季度配件品牌事业部接收信息第一名奖励200分，下月度兑现。</p>
            <p>6、人员招聘：通过自行主动招聘、介绍或转介绍任职成功的人员，奖励动态积分100/次</p>
            <p>7、市场部新客户季度销售额20万元及以上或季度增长率为30%及以上客户，经验分享，激励动态积
分200分/次</p>
            <h4>五、考核：</h4>
            <p>1、配件营销事业部所有人员都有接收和核实信息的责任，并由接收人对信息核实，必须给予信息提供者回复然后以书面形式报事业部统计科存档。</p>
            <p>2、对于拒绝接收信息的负激励500分/次，累计2次以上的按照集团公司员工手册严重违纪处理。</p>
            <p>3、配件品牌事业部人员收到信息不作为、不回复、不报统计科的负激励500分/次，季度累计3次以上的按照集团公司员工手册严重违纪处理。</p>
            <p>4、配件品牌事业部统计科相关人员漏统计100分/次，季度累计3次以上扣除下月度全部绩效。</p>
            <p>5、集团公司任何人员集团公司任何人员未经品牌负责人允许，不得低价销售，为了获取信息报价或直销时对已在售客户和下游渠道未经允许，低于原销售政策时负激励500分/次，并上报集团公司监察部追究后续责任。</p>
            <p>6、市场部人员鱼池客户数据分析及行动计划上报市场部总监，日汇报、周汇报、月汇报，不报者负激励200元/次</p>
            <h4>六、异议监督投诉受理人：</h4>
            <br/>
            <img src={tousushouliren652} alt="" style={{
                width  : '80%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/>
            <p>注：或直接向集团公司监察部投诉</p>
            <br/><br/>
        </div>
    </div>


export default Enclosure65;